/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';

import { Empty } from 'antd';
import cn from 'classnames';

import ActivityTreePane from '#components/ActivityTreePane/ActivityTreePane.jsx';
import { isFeatureOn } from '#utils/featureUtils.js';
import './index.scss';

export function EmptyActivities({
  activeActivityTreePane,
  activitiesTreePanel,
  currentActivityHidden,
  defaultView,
  filterSettings,
  getLookahead,
  isLoading,
  isReloadDataViews,
  setActiveActivityTreePane,
  setActivityTreePaneSettings,
  t
}) {
  useEffect(() => {
    window.loader.hide();
  }, []);

  return (
    <div
      className={cn({
        'activity-pane__container':
          isFeatureOn('enable-LWP-103') && activeActivityTreePane && !isLoading
      })}>
      {isFeatureOn('enable-LWP-103') &&
        activeActivityTreePane &&
        !isLoading && (
          <ActivityTreePane
            activities={activitiesTreePanel}
            actitySettings={defaultView.current.activityTreeSettings}
            closePane={setActiveActivityTreePane}
            filterSettings={filterSettings}
            onCommandDispach={getLookahead}
            viewId={defaultView.current.id}
            setActivityTreePaneSettings={setActivityTreePaneSettings}
            isReloadDataViews={isReloadDataViews}
            t={t}
            currentActivityHidden={currentActivityHidden}
          />
        )}
      <Empty
        style={{ marginTop: 200 }}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<span>{t('no_find_tasks')}</span>}
      />
    </div>
  );
}
